<template>
  <v-stepper
    v-model="step"
    style="max-width: 800px; margin: auto; margin-top: 40px"
    vertical
    non-linear
  >
    <v-stepper-step :complete="step > 1" step="1" editable>
      Bienvenue
    </v-stepper-step>

    <v-stepper-content step="1">
      <p>
        Home in love a crée le compagnon de la mobilité professionnelle pour
        s'occuper de toute la gestion personnelle qui en découle. Vous déménagez
        pour vous rapprocher de votre entreprise ou de votre centre de formation
        ! Nous sommes là pour vous aider : maturation du projet, recherche de
        logement, intégration dans la ville, branchement des fluides... en
        fonction de vos besoins, de vos disponibilités et de vos priorités, nous
        nous adaptons.<br /><br />

        NE CHERCHEZ PLUS, HOME IN LOVE TROUVE POUR VOUS<br /><br />

        Ce service peut être 100% pris en charge par la Subvention du
        Mobili-Pass d’Action Logement, si vous déménagez à plus de 1H15 ou 70km
        de votre logement actuel pour une entreprise/association de plus de
        10personnes. Un doute, une question, n’hesitez pas à nous contacter ou
        remplir le formulaire pour être recontacté.
      </p>

      <div class="d-flex d-flex-initial justify-center">
        <v-btn @click="step = 2" color="accent">Continuer</v-btn>
      </div>
    </v-stepper-content>

    <v-stepper-step :complete="step > 2" step="2" :editable="step > 2">
      Coordonnées
    </v-stepper-step>

    <v-stepper-content step="2">
      <ProjectBasics v-model="basics" :project="project"></ProjectBasics>
      <div class="d-flex d-flex-initial justify-center">
        <v-progress-circular
          indeterminate
          v-if="!loading"
        ></v-progress-circular>
        <v-btn @click="step = 3" color="accent" :disabled="!validInput" v-else
          >Continuer</v-btn
        >
      </div>
    </v-stepper-content>

    <v-stepper-step :complete="step > 3" step="3" :editable="step > 3">
      Professionnel
    </v-stepper-step>

    <v-stepper-content step="3" editable>
      <ProjectCompany
        v-model="company"
        :project="project"
        :use-referer="refererCompany != null"
      ></ProjectCompany>
      <ProjectPrescriber
        v-model="prescriber"
        :project="project"
      ></ProjectPrescriber>
      <div class="d-flex d-flex-initial justify-center">
        <v-progress-circular
          indeterminate
          v-if="saveLoading"
        ></v-progress-circular>
        <v-btn @click="step = 4" color="accent" v-else>Continuer</v-btn>
      </div>
    </v-stepper-content>

    <v-stepper-step :complete="step > 4" step="4" :editable="step > 4">
      Votre projet
    </v-stepper-step>

    <v-stepper-content step="4" editable>
      <ProjectHost
        v-model="host"
        :project="project"
        :is-new="true"
      ></ProjectHost>
      <div class="d-flex d-flex-initial justify-center">
        <v-progress-circular
          indeterminate
          v-if="saveLoading"
        ></v-progress-circular>
        <v-btn @click="step = 5" color="accent" v-else>Continuer</v-btn>
      </div>
    </v-stepper-content>

    <v-stepper-step :complete="step > 5" step="5" :editable="step > 5">
      A propos de vous
    </v-stepper-step>
    <v-stepper-content step="5" editable>
      <ProjectSituation
        v-model="situation"
        :is-new="true"
        :project="project"
      ></ProjectSituation>
      <ProjectServices v-model="services" :project="project"></ProjectServices>
      <div class="d-flex d-flex-initial justify-center">
        <v-progress-circular
          indeterminate
          v-if="saveLoading"
        ></v-progress-circular>
        <v-btn @click="end" color="accent" v-else>Terminer</v-btn>
      </div>
    </v-stepper-content>
    <v-snackbar v-model="showMessage">
      {{ message }}
    </v-snackbar>
  </v-stepper>
</template>
<script>
import ProjectBasics from "../components/project/ProjectBasics";
import ProjectCompany from "../components/project/ProjectCompany";
import ProjectPrescriber from "../components/project/ProjectPrescriber";
import ProjectHost from "../components/project/ProjectHost";
import ProjectSituation from "../components/project/ProjectSituation";
import { fetchHil } from "../utils";
import ProjectServices from "../components/project/ProjectServices";

export default {
  data() {
    return {
      loading: true,
      saveLoading: false,
      basics: null,
      company: null,
      prescriber: null,
      host: null,
      situation: null,
      services: null,
      sponsor: null,
      showMessage: false,
      message: "",
      step: 1,
      projectId: null,
      lease: {
        naturalSubscription: sessionStorage.getItem("referer") === null
      }
    };
  },
  components: {
    ProjectServices,
    ProjectPrescriber,
    ProjectCompany,
    ProjectBasics,
    ProjectHost,
    ProjectSituation
  },
  computed: {
    project() {
      return this.$store.state.currentProject;
    },
    user() {
      return this.$store.state.user;
    },
    refererCompany() {
      const id = localStorage.getItem("companyReferer");
      if (!id) {
        return null;
      }
      return {
        id,
        name: localStorage.getItem("companyRefererName") || ""
      };
    },
    validInput() {
      if (!this.basics) {
        return;
      }
      const { firstName, lastName, phone } = this.basics;

      const requireds = [firstName, lastName, phone];

      return requireds.filter(r => r == null || r === "").length === 0;
    }
  },
  mounted() {
    if (this.user.projectId != null) {
      this.$router.push("/");
    }
  },
  methods: {
    end() {
      this.step += 1;
      this.update();
      this.$router.push(`/`);
    },
    async update() {
      if (this.step === 3) {
        const saleTrigram = sessionStorage.getItem("referer") || "";
        const {
          actualCity,
          actualCityObject,
          dateMove,
          firstName,
          lastName,
          phone,
          sponsor,
          serviceWish,
          moveWish
        } = this.basics;
        this.lease = {
          ...this.lease,
          actualCity,
          firstName,
          lastName,
          phoneNumber: phone,
          fromAddressObject: actualCityObject,
          dateMove,
          sponsor,
          assignees: {
            sale: saleTrigram
          },
          school: this.refererCompany?.name,
          prescriberId: this.refererCompany?.id,
          serviceWish,
          moveWish
        };
      } else if (this.step === 4) {
        const {
          contractType,
          company,
          companyPhone,
          companyMail,
          companyId,
          addressWork,
          addressWorkObject
        } = this.company;
        const {
          school,
          schoolMail,
          schoolPhone,
          prescriberId
        } = this.prescriber;
        this.lease = {
          ...this.lease,
          companyMail,
          companyPhone,
          contractType,
          company: this.refererCompany ? this.refererCompany.name : company,
          addressWork,
          addressWorkObject,
          school,
          schoolMail,
          schoolPhone,
          companyId: this.refererCompany ? this.refererCompany.id : companyId,
          prescriberId
        };
      } else if (this.step === 5) {
        const {
          favoritePlaces,
          typeOfEstate,
          surfacemin,
          budget,
          numberOfRoom,
          descEstate,
          futurNeighborhood,
          criterion1,
          criterion2,
          criterion3
        } = this.host;
        this.lease = {
          ...this.lease,
          favoritePlaces,
          typeOfEstate,
          surfacemin: surfacemin === "" ? undefined : surfacemin,
          budget: budget === "" ? undefined : budget,
          numberOfRoom: numberOfRoom === "" ? undefined : numberOfRoom,
          descEstate,
          futurNeighborhood,
          criterion1,
          criterion2,
          criterion3
        };
      } else if (this.step === 6) {
        const { aboutYou } = this.situation;
        const services = this.services?.services;
        this.lease = {
          ...this.lease,
          aboutYou,
          services
        };
      }
      if (this.step > 2) {
        this.saveLoading = true;
        try {
          if (this.projectId === null) {
            const l = await fetchHil(`/lease`, {
              method: "POST",
              body: this.lease
            });

            if (!l.ok) {
              console.error("could not save");
              this.saveLoading = false;
              this.message = "Une erreur a eu lieu";
              this.showMessage = true;
              return;
            }

            const createdLease = await l.json();

            // Update assignees as it can be server-generated
            this.lease.assignees = createdLease.assignees;

            this.projectId = createdLease._id;
          } else {
            this.saveLoading = true;
            const resp = await fetchHil(`/lease/${this.projectId}`, {
              method: "PUT",
              body: this.lease
            });

            if (!resp.ok) {
              this.saveLoading = false;
              console.error("could not update");
              this.message = "Une erreur a eu lieu";
              this.showMessage = true;
            }
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.saveLoading = false;
        }
      }
    }
  },
  watch: {
    async step() {
      return this.update();
    }
  }
};
</script>
<style></style>
